import { Typography } from '@design-system/components/typography/typography';
import { TypedValue } from '@client/new/helpers/types';
import { MediaType } from '../../../model/Challenges.types';
import * as styles from './Media.css';

export type MediaVM = TypedValue<MediaType | 'none', string>;

export const Media = (p: MediaVM & { width?: string; height?: string }) => {
  if (p.type === 'none')
    return (
      <div
        className={styles.emptyMedia}
        style={{
          ...(p.width ? { width: p.width } : {}),
          ...(p.height ? { height: p.height } : {}),
        }}
      >
        <Typography fontWeight="bold" style={{ maxWidth: 85 }}>
          {p.value}
        </Typography>
      </div>
    );
  return <img src={p.value} className={styles.imageMedia} />;
};
